import Photo from "@components/new/Photo";
import { TableRowType, TableCellLink, TableColumn } from "@components/new/Table";
import {
  isWbRequestItem,
  isUnknownRequestItem,
} from "@api/apiClient/fbp";
import { TLinkRow } from "./types";
import { formatNumber } from "@utils/formatValues";
import emptyImg from '@assets/img/empty.png';
import styles from './Form.module.scss';

function getItemsColumns(
  t: (v: string) => string,
): TableColumn<TLinkRow>[] {
  return [
    {
      header: t("fbpPage.delStoreModal.columns.photo"),
      renderCell: (row: TableRowType<TLinkRow>) => (
        isUnknownRequestItem(row.data) ? (
          <img src={emptyImg} alt="" className={styles.emptyImage} />
        ) : (
          <Photo src={row.data.primaryImage} />
        )
      ),
      width: "80px",
      fixWidth: true,
    },
    {
      header: t("fbpPage.delStoreModal.columns.name"),
      renderCell: (row: TableRowType<TLinkRow>) => {
        const description = isWbRequestItem(row.data) ? row.data.wbNmId : row.data.sku;
        return (
          <TableCellLink
            title={row.data.name}
            description={description}
            to={row.data.url}
            external
            maxWidth="460px"
          />
        )
      },
      width: "500px",
    },
    {
      header: t("fbpPage.delStoreModal.columns.size"),
      valueGetter: (row: TLinkRow) => ((isWbRequestItem(row) && row.wbTechSize) || ""),
      width: "80px",
      fixWidth: true,
      alignment: "center",
    },
    {
      header: t("fbpPage.delStoreModal.columns.count"),
      renderCell: (row: TableRowType<TLinkRow>) => (formatNumber(row.data.present)),
      width: "100px",
      fixWidth: true,
    },
  ]
}

export default getItemsColumns
